const {
  appFields,
  renderFieldWrapper,
} = require('./field.common.js');
const templateHelper = require('./field.utils.js');

module.exports = {
  fields: appFields,
  renderField: renderFieldWrapper(templateHelper, appFields),
};
